/**
 * tarefas.ts — chamadas tipadas do piloto Tarefas/Lembretes (F3).
 */

import type { components } from './generated/api'
import { api } from './http'

export type Tarefa = components['schemas']['Tarefa']
export type Tarefas = components['schemas']['Tarefas']
export type Lembrete = components['schemas']['Lembrete']

export function listarTarefas() {
  return api<Tarefas>('/api/v1/tarefas')
}

export function criarTarefa(titulo: string, processoId?: number) {
  return api<Tarefa>('/api/v1/tarefas', {
    method: 'POST',
    body: { titulo, processo_id: processoId ?? null },
  })
}

export function definirConclusao(id: number, concluida: boolean) {
  return api<Tarefa>(`/api/v1/tarefas/${id}`, {
    method: 'PATCH',
    body: { concluida },
  })
}

export function excluirTarefa(id: number) {
  return api<null>(`/api/v1/tarefas/${id}`, { method: 'DELETE' })
}

export function listarLembretes(filtro?: { mes: number; ano: number }) {
  const consulta = filtro ? `?mes=${filtro.mes}&ano=${filtro.ano}` : ''
  return api<{ lembretes: Lembrete[] }>(`/api/v1/lembretes${consulta}`)
}

export function criarLembrete(dados: {
  titulo: string
  data: string
  descricao?: string
  hora?: string | null
}) {
  return api<Lembrete>('/api/v1/lembretes', { method: 'POST', body: dados })
}

export function marcarLembreteLido(id: number) {
  return api<null>(`/api/v1/lembretes/${id}`, {
    method: 'PATCH',
    body: { lido: true },
  })
}

export function excluirLembrete(id: number) {
  return api<null>(`/api/v1/lembretes/${id}`, { method: 'DELETE' })
}
